import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import type { Theme } from "@/routes/~dashboard/~presentation/presentation-data";

interface SettingsPanelProps {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export default function SettingsPanel({ theme, setTheme }: SettingsPanelProps) {
  const handleThemeChange = (key: keyof Theme, value: string | boolean) => {
    setTheme({
      ...theme,
      [key]: value,
    });
  };

  const themeCollection = [
    {
      name: "Professional",
      slideBackground: "#ffffff",
      titleColor: "#1a1a1a",
      textColor: "#333333",
      fontFamily: "'Arial', 'Helvetica', sans-serif",
    },
    {
      name: "Dark Mode",
      slideBackground: "#121212",
      titleColor: "#ffffff",
      textColor: "#e0e0e0",
      fontFamily: "'Roboto', 'SF Pro Display', sans-serif",
    },
    {
      name: "Ocean",
      slideBackground: "#f0f9ff",
      titleColor: "#0c4a6e",
      textColor: "#0e7490",
      fontFamily: "'Montserrat', 'Trebuchet MS', sans-serif",
    },
    {
      name: "Forest",
      slideBackground: "#f0fdf4",
      titleColor: "#166534",
      textColor: "#3f6212",
      fontFamily: "'Georgia', 'Garamond', serif",
    },
    {
      name: "Sunset",
      slideBackground: "#fdf2f8",
      titleColor: "#be185d",
      textColor: "#9d174d",
      fontFamily: "'Playfair Display', 'Times New Roman', serif",
    },
    {
      name: "Vibrant",
      slideBackground: "#581c87",
      titleColor: "#e9d5ff",
      textColor: "#c4b5fd",
      fontFamily: "'Poppins', 'Verdana', sans-serif",
    },
  ];

  const applyTheme = (themeConfig: (typeof themeCollection)[0]) => {
    setTheme({
      ...theme,
      slideBackground: themeConfig.slideBackground,
      titleColor: themeConfig.titleColor,
      textColor: themeConfig.textColor,
      fontFamily: themeConfig.fontFamily,
    });
  };

  return (
    <div className="space-y-6 p-4 text-white">
      <div className="space-y-2">
        <Label htmlFor="presentation-name">Presentation Name</Label>
        <Input
          id="presentation-name"
          className="border-slate-800 bg-slate-800 text-secondary-foreground"
          placeholder="My Presentation"
          value={theme.presentationName || ""}
          onChange={(e) =>
            handleThemeChange("presentationName", e.target.value)
          }
        />
      </div>

      <div>
        <h3 className="ml-4 text-sm font-medium">Theme Collection</h3>
        <div className="flex flex-col gap-3 pl-2 pt-4">
          {themeCollection.map((themeConfig, index) => (
            <Card
              key={index}
              className="h-32 w-60 cursor-pointer overflow-hidden transition-all hover:scale-105"
              style={{ background: themeConfig.slideBackground }}
              onClick={() => applyTheme(themeConfig)}
            >
              <div className="p-4">
                <h4
                  className="mb-2 text-sm font-medium"
                  style={{ color: themeConfig.titleColor }}
                >
                  {themeConfig.name}
                </h4>
                <div
                  className="text-xs"
                  style={{ color: themeConfig.textColor }}
                >
                  Sample text
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
